module.exports = __webpack_public_path__ + "img/388.0f0466ba.png";